import {
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   useColorModeValue,
   Grid,
   GridItem,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import {
   getReportSaleDetail,
   getReportLedger,
   getReportOutstanding,
   getProfitLossMonthly,
} from '../../../../redux/actions/reports';
import { getAccount } from '../../../../redux/actions/account';
import { getDaybook } from '../../../../redux/actions/daybook';
import { useUser, useGlobal } from 'contexts';
import { getGLGroups } from '../../../../redux/actions/glGroup';
import MultiSelectDropdown from 'components/ui/MultiSelectDropdown';
import AddEditForm from '../../masters/Pages/AllAccountMaster/AddEditFormForAccount';
import DaybookForm from '../../masters/Pages/DaybookMaster/DaybookForm';
import LedgerMasterForm from '../../masters/Pages/LedgerMaster/LedgerMasterForm';

function StockFilter({ isOpen, onClose, companyIds, fromDate, toDate, entityType, osType, onApply }) {
   const { user } = useUser();
   const dispatch = useDispatch();
   const { cityList, stateList } = useGlobal();
   const textColor = useColorModeValue('gray.500', 'white');
   const isColorMode = useColorModeValue(true, false);
   const accountData = useSelector((state) => state.account.list || []);
   const daybookData = useSelector((state) => state.daybook.list || []);
   const glGroupData = useSelector((state) => state.glGroup.list || []);
   const { userGlobalSettingsData } = useGlobal();
   const globalSettingAcc = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdownAcc = globalSettingAcc || false;
   const globalSettingDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook;
   const shouldShowCompanyDropdownDaybook = globalSettingDaybook || false;
   const initialFormData = {
      accountIds: [],
      daybookIds: [],
      contraAccIds: [],
      glIds: [],
      cityId: [],
      stateId: [],
   };

   const [formData, setFormData] = useState(initialFormData);

   useEffect(() => {
      if (isOpen) {
         getAccount({
            ...(shouldShowCompanyDropdownAcc &&
               companyIds?.length && {
               companyIds: companyIds.join(','),
            }),
            companyId: user?.loginhistory?.companyId,
            status: true,
         });
         if (entityType === 'outstanding') {
            dispatch(
               getDaybook({
                  ...(shouldShowCompanyDropdownDaybook &&
                     companyIds?.length && {
                     companyIds: companyIds.join(','),
                  }),
                  companyId: user?.loginhistory?.companyId,
               }),
            );
         }
         if (entityType === 'profitLoss') {
            dispatch(getGLGroups());
         }
      }
   }, [dispatch, isOpen, user, entityType, companyIds, shouldShowCompanyDropdownAcc, shouldShowCompanyDropdownDaybook]);

   const handleAccountChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, accountIds: selectedValues || [] }));
   };

   const handleDaybookChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, daybookIds: selectedValues || [] }));
   };

   const handleGLGroupChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, glIds: selectedValues || [] }));
   };

   const handleCityChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, cityId: selectedValues || [] }));
   };

   const handleStateChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, stateId: selectedValues || [] }));
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      onApply?.();
      onClose();
      const payload = {
         companyIds: companyIds.toString(),
         fromDate: fromDate,
         toDate: toDate,
      };

      // Add osType only for outstanding reports
      if (entityType === 'outstanding') {
         payload.isPurchaseOs = osType;
      }

      // Add account IDs if present (common for both)
      if (formData.accountIds.length > 0) payload.accIds = formData.accountIds.join(',');

      // Add daybook IDs only for outstanding reports
      if (entityType === 'outstanding' && formData.daybookIds.length > 0) {
         payload.daybookIds = formData.daybookIds.join(',');
      }

      // Add GL Group IDs only for profitLoss reports
      if (entityType === 'profitLoss' && formData.glIds.length > 0) {
         payload.glIds = formData.glIds.join(',');
      }

      if (entityType === 'outstanding' && formData.cityId.length > 0) {
         payload.cityIds = formData.cityId.join(',');
      }

      if (entityType === 'outstanding' && formData.stateId.length > 0) {
         payload.stateIds = formData.stateId.join(',');
      }

      switch (entityType) {
         case 'statement':
            dispatch(getReportLedger(payload));
            break;
         case 'outstanding':
            dispatch(getReportOutstanding(payload));
            break;
         case 'profitLoss':
            dispatch(getProfitLossMonthly(payload));
            break;
         default:
            console.warn('Unknown entityType:', entityType);
      }

      onClose();
   };

   const handleClear = () => {
      setFormData(initialFormData);
      const payload = {
         companyIds: companyIds.toString(),
         fromDate: fromDate,
         toDate: toDate,
      };

      // Add osType only for outstanding reports
      if (entityType === 'outstanding') {
         payload.isPurchaseOs = osType;
      }

      switch (entityType) {
         case 'statement':
            dispatch(getReportLedger(payload));
            break;
         case 'outstanding':
            dispatch(getReportOutstanding(payload));
            break;
         case 'profitLoss':
            dispatch(getProfitLossMonthly(payload));
            break;
         default:
            console.warn('Unknown entityType:', entityType);
      }
   };

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
         <ModalOverlay />
         <ModalContent as="form" onSubmit={handleSubmit}>
            <ModalHeader>Filter</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
               <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                  {/* Account field - common for all */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'accountid',
                        'Account',
                        accountData,
                        {
                           value: formData.accountIds,
                           onChange: handleAccountChange,
                           showCustomNoOptions: true,
                           openfrom: 'account',
                        },
                        {},
                        textColor,
                        true,
                        'Select Account',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Account"
                        options={accountData}
                        value={formData.accountIds}
                        onChange={handleAccountChange}
                        placeholder="Select Account"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log("handleAddNew", value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={AddEditForm}
                        error={""}
                     />
                  </GridItem>

                  {/* Daybook field - only for outstanding */}
                  {entityType === 'outstanding' && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'daybookid',
                           'Daybook',
                           daybookData,
                           {
                              value: formData.daybookIds,
                              onChange: handleDaybookChange,
                              showCustomNoOptions: true,
                              openfrom: 'daybook',
                           },
                           {},
                           textColor,
                           true,
                           'Select Daybook',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Daybook"
                           options={daybookData}
                           value={formData.daybookIds}
                           onChange={handleDaybookChange}
                           placeholder="Select Daybook"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={DaybookForm}
                           error={''}
                        />
                     </GridItem>
                  )}

                  {/* GL Group field - only for profitLoss */}
                  {entityType === 'profitLoss' && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'glid',
                           'GL Group',
                           glGroupData,
                           {
                              value: formData.glIds,
                              onChange: handleGLGroupChange,
                              showCustomNoOptions: true,
                              openfrom: 'ledger',
                           },
                           {},
                           textColor,
                           true,
                           'Select GL Group',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="GL Group"
                           options={glGroupData}
                           value={formData.glIds}
                           onChange={handleGLGroupChange}
                           placeholder="Select GL Group"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={LedgerMasterForm}
                           error={''}
                        />
                     </GridItem>
                  )}

                  {entityType === 'outstanding' && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'cityId',
                           'City',
                           cityList,
                           {
                              value: formData.cityId,
                              onChange: handleCityChange,
                           },
                           {},
                           textColor,
                           true,
                           'Select Daybook',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="City"
                           options={cityList}
                           value={formData.cityId}
                           onChange={handleCityChange}
                           placeholder="Select City"
                           isRequired={true}
                           showAddButton={false}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={null}
                           error={''}
                        />
                     </GridItem>
                  )}

                  {entityType === 'outstanding' && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'stateId',
                           'State',
                           stateList,
                           {
                              value: formData.stateId,
                              onChange: handleStateChange,
                           },
                           {},
                           textColor,
                           true,
                           'Select Daybook',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="State"
                           options={stateList}
                           value={formData.stateId}
                           onChange={handleStateChange}
                           placeholder="Select State"
                           isRequired={true}
                           showAddButton={false}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={null}
                           error={''}
                        />
                     </GridItem>
                  )}
               </Grid>
            </ModalBody>

            <ModalFooter>
               <Button type="submit" colorScheme="green" mr={3}>
                  Apply Filters
               </Button>
               <Button onClick={handleClear}>Reset</Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
}

export default StockFilter;
